export enum QueryKeys {
  GetBankList = "GetBankList",
  GetMemberVPosList = "GetMemberVPosList",
  GetUserList = "GetUserList",
  GetMerchantList = "GetMerchantList",
  GetUserRoleList = "GetUserRoleList",
  GetUserDetail = "GetUserDetail",
  DeleteUser = "DeleteUser",
  GetUserTypeList = "GetUserTypeList",
  GetMerchantType = "GetMerchantType",
  GetPosType = "GetPosType",
  GetCurrencyCode = "GetCurrencyCode",
  GetCardType = "GetCardType",
  GetCommissionProfileList = "GetCommissionProfileList",
  GetCommissionParameterList = "GetCommissionParameterList",
  GetCityList = "GetCityList",
  GetDistrictList = "GetDistrictList",
  GetTaxAdministrationList = "GetTaxAdministrationList",
  GetMerchantCategoryList = "GetMerchantCategoryList",
  GetRoleList = "GetRoleList",
  GetMerchantStatusList = "GetMerchantStatusList",
  GetUserLoginDetail = "GetUserLoginDetail",
  GetMemberVPosDetail = "GetMemberVPosDetail",
  GetDefaultVPosSettingsDetail = "GetDefaultVPosSettingsDetail",
  GetSettingsMerchantType = "GetSettingsMerchantType",
  GetSettingsInstallmentCount = "GetSettingsInstallmentCount",
  GetMenuList = "GetMenuList",
  GetMenuTypeList = "GetMenuTypeList",
  GetResourceList = "GetResourceList",
  GetResourceType = "GetResourceType",
  GetRoleMenuList = "GetRoleMenuList",
  GetVPosRoutingList = "GetVPosRoutingList",
  GetIssuerBankList = "GetIssuerBankList",
  GetAcquirerBankList = "GetAcquirerBankList",
  GetPaymentAndTransaction = "GetPaymentAndTransaction",
  GetTransactionStatusList = "GetTransactionStatusList",
  GetPayment3DTrxList = "GetPayment3DTrxList",
  GetTransactionSubTypeList = "GetTransactionSubTypeList",
  GetCardBinList = "GetCardBinList",
  GetCampaignList = "GetCampaignList",
  GetPaymentModelList = "GetPaymentModelList",
  GetDashboardTransactionList = "GetDashboardTransactionList",
  GetUserMenuList = "GetUserMenuList",
  GetLinkedPaymentStatusList = "GetLinkedPaymentStatusList",
  GetAllMerchantList = "GetAllMerchantList",
  GetAllRoleList = "GetAllRoleList",
  GetAllMenuList = "GetAllMenuList",
  GetMerchantVposGetList = "GetMerchantVposGetList",
  GetDocumentList = "GetDocumentList",
  GetAnnulmentCodeList = "GetAnnulmentCodeList",
  GetCardBinByBankCode = "GetCardBinByBankCode",
  GetCardTypeByBin = "GetCardTypeByBin",
  GetMerchantsWithParentMerchant = "GetMerchantsWithParentMerchant",
  GetMicroserviceStatusList = "GetMicroserviceStatusList",
  GetSettingsPasswordMaxLength = "GetSettingsPasswordMaxLength",
  GetSettingsMerchantLimit = "GetSettingsMerchantLimit",
  GetMemberVposBankList = "GetMemberVposBankList",
  MerchantCurrentBalanceType = "MerchantCurrentBalanceType",
  AnnulmentQueriesList = "AnnulmentQueriesList",
  GetMerchantStatusCounts = "GetMerchantStatusCounts",
  responseCodes = "responseCodes",
  newResponseCodes = "newResponseCodes",
  GetMerchantPassiveReasons = "GetMerchantPassiveReasons",
  GetMerchantWithVkn = "GetMerchantWithVkn",
  GetMerchantWithTckn = "GetMerchantWithTckn",
  SearchMobilEftPos = "SearchMobilEftPos",
  SearchFixedEftPos = "SearchFixedEftPos",
  GetMerchantBlackListReasons = "GetMerchantBlackListReasons",
  UpdateMerchantStatusType = "UpdateMerchantStatusType",
  GetVPosIntegrationStatus = "GetVPosIntegrationStatus",
  GetIPRestrictionList = "GetIPRestrictionList",
  CreateIPRestriction = "CreateIPRestriction",
  UpdateIPRestriction = "UpdateIPRestriction",
  DeleteIPRestriction = "DeleteIPRestriction",
  GetEneryaReconciliationList = "GetEneryaReconciliationList",
  ImportEneryaReconciliation = "ImportEneryaReconciliation",
  GetReconciliationFileStatus = "GetReconciliationFileStatus",
  GetActiveGMUStores = "GetActiveGMUStores"
}
